module.exports = __webpack_public_path__ + "img/bg-learn-about-gideons.jpg";